// extracted by mini-css-extract-plugin
export default {"delivery-address":"OhOrderNote_delivery-address__fbVlB","bold":"OhOrderNote_bold__zb52p"};